(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .controller("EditCertificateModalCtrl", ["learningPathVersionLocalizationResource", "frameworkService", "messageService", "data", "$scope", "$state", "$filter", "$translate", "_", editCertificateModalCtrl]);
    function editCertificateModalCtrl(learningPathVersionLocalizationResource, frameworkService, messageService, data, $scope, $state, $filter, $translate, _) {
        var vm = this;
        var params = $state.params;
        vm.showErrors = false;
        vm.saving = false;
        vm.enabledLocalizations = frameworkService.data.tenant.enabledLocalizations;
        vm.defaultLocalizationId = frameworkService.data.tenant.defaultLocalization.id;
        learningPathVersionLocalizationResource.getEditCertificateModalView({ number: params.number, version: data.version }, function (result) {
            vm.model = result;
        });
        vm.getTranslatedLanguage = function (localizationId) {
            var localization = _.find(vm.enabledLocalizations, { id: localizationId });
            var name = $filter("removeSpaces")(localization.name);
            return $translate.instant("common.localization." + name);
        };
        vm.save = function () {
            if (vm.saving)
                return;
            vm.saving = true;
            learningPathVersionLocalizationResource.saveCertificates({ number: params.number, version: data.version }, vm.model, function (result) {
                $scope.$close(result);
            }, function () {
                vm.saving = false;
                messageService.error("common.genericError");
            });
        };
    }
}());
